import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-lazy-load-image-component/src/effects/black-and-white.css";
import "react-lazy-load-image-component/src/effects/opacity.css";

const Image = ({
  src,
  width,
  height,
  alt,
  effect,
  classes,
  showErrorImage = false,
  onError = () => {},
}) => {
  const [hasError, setHasError] = useState(false);

  const handleError = (e) => {
    setHasError(true);
    onError(e);
  };

  if (hasError || !src) {
    return (
      <div 
        className={`w-full h-full bg-md-pink-dark rounded-2xl flex items-center justify-center text-white text-center p-4 ${classes}`}
        style={{ width, height }}
      >
        <span className="text-4xl font-medium">
          {alt || "Image unavailable"}
        </span>
      </div>
    );
  }

  return (
    <>
      <LazyLoadImage
        onError={handleError}
        src={src}
        width={width}
        height={height}
        alt={alt}
        effect={effect}
        className={"w-full h-full " + classes}
        crossOrigin="anonymous"
      />
    </>
  );
};

export default Image;